// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"d8b0adb5","60":"d8b0adb5","957":"d8b0adb5"}[chunkId] + ".chunk.css";
};